import ReassuranceModal from './ReassuranceModal.vue'

export default ReassuranceModal
